import { formatDate } from 'js-utils/datetime';
import lazyGettext from 'js-utils/lazy-gettext';
import moment from 'js-utils/moment';

export const CREATE_SCHEDULE_PUBLISH_FORM_NAME = 'createSchedulePublish';
export const PUBLISH_PREVIEW_SCHEDULE_PUBLISH_FORM_NAME =
    'publishPreviewSchedulePublish';

export const EVENT_DATE_PICKER_PREFIX = 'scheduleEventPublish-';
export const MIN_PUBLISH_DATE = formatDate(moment());

export const SCHEDULE_PUBLISH_SCHEDULED = 'scheduled';
export const SCHEDULE_PUBLISH_STATUS = 'schedule_publish_status';
export const SCHEDULE_PUBLISH_DATE = 'schedule_publish_date';

export const PUBLISH_LABEL = lazyGettext('Publish');
export const SCHEDULE_PUBLISH_LABEL = lazyGettext('Schedule');
export const PUBLISH_COPY = lazyGettext('Publish Now');
export const SCHEDULE_COPY = lazyGettext('Schedule Publish');
export const SCHEDULE_PUBLISH_DATA_HEADLINE = lazyGettext('Publish Options');
export const EVENT_SALES_STATUS_EXPANSION = 'event_sales_status';
export const EVENT_STATUS_DRAFT = 'draft';

export const PUBLISH_CHECKBOX_VALUE = 'publish';
export const SCHEDULE_CHECKBOX_VALUE = 'schedule-publish';

export const BASIC_INVENTORY_INFO_EXPANSION = 'basic_inventory_info';
export const EVENT_API_EXPANSIONS = [BASIC_INVENTORY_INFO_EXPANSION];
export const EVENT_API_GET_EXPANSIONS = [
    EVENT_SALES_STATUS_EXPANSION,
    BASIC_INVENTORY_INFO_EXPANSION,
];
export const STATE_RESOURCE_CACHE_NAME = 'resourceCache';

export const SHOW_SCHEDULE_PUBLISH_NOTIFICATION_DELAY = 20000;
